import { Icon, Modal, Spin } from "ant-design-vue";
import { Component, Ref, Vue } from "vue-property-decorator";
import { ActionItem, fmtMsg, MessageHelper, NotificationType, ServerExceptionCode } from "commonui";
import Grid from "@/components/wijmo-grid/grid/grid.vue";
import { CommonIntentListModel, ConversationTemplateService } from "@/services/conversation-templates";
import { CommonIntentsLocale, CommonLocale } from "@/locales/localeid";
import { GridRef } from "@/components/wijmo-grid/grid/grid";
import CommonIntentsForm from "@/components/common-intents-form/common-intents-form.vue";
import { AccessLevel } from "@/util/enum";
import { disabledDueToAccessLevel, getRouteAccessLevel } from "@/util/func";

@Component({
	components: {
		Grid,
		Icon,
		Spin,
		ActionItem,
		CommonIntentsForm
	}
})
export default class CommonIntents extends Vue {
	@Ref() readonly gridCompRef!: GridRef;
	private templateService = ConversationTemplateService();
	public loading: boolean = false;
	public format = fmtMsg;
	public locale = CommonIntentsLocale;
	public commonLocale = CommonLocale;
	public isAddEditDrawerVisible = false;
	public commonIntents: CommonIntentListModel[] = [];
	public selectedIntentId: number = 0;
	public acessLevel = AccessLevel;

	get currentRouteAccessLevel() {
		return getRouteAccessLevel(this.$route);
	}

	get disabledDueToAccessLevel() {
		return disabledDueToAccessLevel(this.currentRouteAccessLevel);
	}

	created() {
		this.getCommonIntents();
	}

	getCommonIntents() {
		this.loading = true;
		this.templateService
			.getCommonIntents()
			.then((data) => {
				this.commonIntents = data;
				this.loading = false;
			})
			.catch(() => {
				this.loading = false;
			});
	}
	showErrorMessage({ error_code, error_description }) {
		switch (error_code) {
			case ServerExceptionCode.CommonIntentAssociationException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.locale.CommonIntentsStrongAssociationMessage)
				);
				break;
			case ServerExceptionCode.CommonIntentNotExistException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.locale.CommonIntentsNotExistErrorMessage)
				);
				break;
			case ServerExceptionCode.ArgumentIsNullOrInvalidException:
				MessageHelper.Message(
					NotificationType.Failed,
					this.format(this.commonLocale.CommonHttpArgumentIsNullOrInvalid)
				);
				break;
		}
	}

	deleteCommonIntent(id: number) {
		const onOk = async () => {
			this.loading = true;
			this.templateService
				.deleteCommonIntent(id)
				.then((data) => {
					this.loading = false;
					MessageHelper.Message(
						NotificationType.Success,
						this.format(this.locale.CommonIntentsDeleteSuccessMessage)
					);
					this.getCommonIntents();
				})
				.catch(({ error_code, error_description }) => {
					this.showErrorMessage({ error_code, error_description });
					this.loading = false;
				});
		};

		Modal.confirm({
			okText: fmtMsg(this.locale.CommonIntentsDeleteButtonText),
			title: fmtMsg(this.locale.CommonIntentsDeleteWarning),
			onOk
		});
	}

	addEditIntent(id?: number) {
		if (!id) {
			// New Intent
			this.selectedIntentId = 0;
		} else {
			this.selectedIntentId = id;
		}
		this.isAddEditDrawerVisible = true;
	}

	onAddEditDrawerClose(reloadRequired: boolean) {
		this.isAddEditDrawerVisible = false;
		if (reloadRequired) {
			this.getCommonIntents();
		}
	}
}
